document.addEventListener("DOMContentLoaded", function () {
    const preferredSizes = ["L", "M"];

    function selectPreferredSize() {
        const sizeOptions = document.querySelectorAll('.input-checkbox[name="option-0"]');

        if (sizeOptions.length === 0) {
            console.warn("Size options not found yet. Retrying...");
            return;
        }

        let selected = false;

        for (let size of preferredSizes) {
            let sizeOption = Array.from(sizeOptions).find(input => input.value === size && !input.disabled);
            if (sizeOption) {
                sizeOption.checked = true;
                sizeOption.dispatchEvent(new Event("change", { bubbles: true })); // Ensure update triggers
                selected = true;
                //console.log(`Auto-selected size: ${size}`);
                break;
            }
        }

        if (!selected) {
            console.warn("No preferred size available.");
        }
    }

    function waitForProductOptions() {
        const productOptionsContainer = document.querySelector(".product-options");
        
        if (!productOptionsContainer) {
            console.warn("Waiting for product options to load...");
            setTimeout(waitForProductOptions, 100); // Retry every 100ms
            return;
        }

        // Now that the product options are loaded, set up the observer
        const observer = new MutationObserver((mutations, obs) => {
            if (document.querySelector('.input-checkbox[name="option-0"]')) {
                selectPreferredSize();
                obs.disconnect(); // Stop observing after selecting size
            }
        });

        observer.observe(productOptionsContainer, { childList: true, subtree: true });

        // Also attempt selection in case elements are already present
        selectPreferredSize();
    }

    // Start the waiting process
    waitForProductOptions();
});
